import { TransactionalHistoryTableTranslations } from "./transactional-history-table-pt-br";

export const TRANSACTIONAL_HISTORY_TABLE_ES_MX: TransactionalHistoryTableTranslations = {
	columns: {
		transaction: "Transacción",
		seller: "Vendedor",
		zigCode: "ZigTag",
		value: "Valor",
		id: "ID",
		time: "Hora de la transacción",
		sync: "Sincronización",
	},
	withoutInfo: "Sin información",
	noCard: "Sin tarjeta",
};
